import { render, staticRenderFns } from "./no-data.vue?vue&type=template&id=56fb5cdc"
import script from "./no-data.vue?vue&type=script&lang=js"
export * from "./no-data.vue?vue&type=script&lang=js"
import style0 from "./no-data.vue?vue&type=style&index=0&id=56fb5cdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports